const ITEMS = [
    "Fresatura CNC a 3 assi",
    "Pezzi su misura",
    "Stampi",
    "Prototipi",
    "Lavorazioni ferro",
    "Lavorazioni alluminio",
    "Rettifica centesimale",
    "Brivio — Lecco — Lombardia",
];

export default function Marquee() {
    const row = ["a", "b"].flatMap((pass) => ITEMS.map((item) => ({ key: `${pass}-${item}`, item })));
    return (
        <div
            data-testid="marquee-ribbon"
            className="overflow-hidden border-y border-tl-orange/25 bg-tl-dark3 py-5"
            aria-hidden="true"
        >
            <div className="animate-tl-marquee flex w-max items-center gap-10 whitespace-nowrap">
                {row.map(({ key, item }) => (
                    <span
                        key={key}
                        className="flex items-center gap-10 font-mono-tl text-xs uppercase tracking-[0.3em] text-white/60"
                    >
                        {item}
                        <span className="block h-1.5 w-1.5 rotate-45 bg-tl-orange" />
                    </span>
                ))}
            </div>
        </div>
    );
}
